import Swiper from "swiper";
import { Navigation } from "swiper/modules";
import "swiper/css";

export function initRelatedProducts() {
  const swipers = document.querySelectorAll(".related-products__swiper, .more-categories__swiper");

  swipers.forEach((el) => {
    const isMoreCategories = el.classList.contains("more-categories__swiper");

    new Swiper(el, {
      modules: [Navigation],
      slidesPerView: 1.2,
      spaceBetween: 15,
      speed: 800,
      navigation: {
        prevEl: ".related-products__btn-prev",
        nextEl: ".related-products__btn-next",
      },
      breakpoints: isMoreCategories
        ? {
            576: { slidesPerView: 2.2, spaceBetween: 20 },
            768: { slidesPerView: 2.2, spaceBetween: 20 },
            1200: { slidesPerView: 3, spaceBetween: 20 },
          }
        : {
            576: { slidesPerView: 2.2, spaceBetween: 20 },
            768: { slidesPerView: 3.2, spaceBetween: 20 },
            1200: { slidesPerView: 4, spaceBetween: 20 },
          },
    });
  });
}
